import { render, staticRenderFns } from "./DepositDetailsViewNew.vue?vue&type=template&id=844d80f8&"
import script from "./DepositDetailsViewNew.vue?vue&type=script&lang=js&"
export * from "./DepositDetailsViewNew.vue?vue&type=script&lang=js&"
import style0 from "./DepositDetailsViewNew.vue?vue&type=style&index=0&id=844d80f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports